import { DataContext } from 'contexts/DataContextContainer'
import { useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import HowItWorksCards from './HowItWorksCards'
import HowItWorksFeatures from './HowItWorksFeatures'
import HowItWorksHero from './HowItWorksHero'
import { HowItWorksContainer } from './style'

function HowItWorks() {
  const { lang } = useContext(DataContext)
  const { t } = useTranslation()
  useEffect(() => {
    document.title = t('pg_title_how_it_works')
  }, [lang, t])

  return (
    <HowItWorksContainer>
      <HowItWorksHero />
      <HowItWorksCards />
      <HowItWorksFeatures />
    </HowItWorksContainer>
  )
}

export default HowItWorks
